//ResetPasswordForm.js
import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Form, Button, Alert, Container, Row, Col } from 'react-bootstrap';

function ResetPasswordForm() {
  const [searchParams] = useSearchParams();
  const resetToken = searchParams.get('token');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    // Simulate API call
    try {
      // Replace this with your actual API call
      const response = await fetch('https://backend-spanga.onrender.com/api/reset-password', {
        // const response = await fetch('http://localhost:3001/api/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ resetToken, newPassword }),
      });

      if (response.ok) {
        setMessage('Ditt lösenord har återställts framgångsrikt.');
        setTimeout(() => navigate('/login'), 5000); // Redirect to login after 5 seconds
      } else {
        setError('Det gick inte att återställa lösenordet. Försök igen.');
      }
    } catch (error) {
      setError('Ett fel uppstod. Försök igen.');
    }
  };

  return (
    <section className="py-5 h-100" style={{ backgroundColor: '#fff' }}>
      <Container className="py-5 h-100">
        <Row className="d-flex justify-content-center align-items-center h-100">
          <Col md={8} lg={6} xl={5}>
            <div className="card shadow-sm bg-light" style={{ borderRadius: "1rem" }}>
              <div className="card-body p-4 p-md-5 text-center">

                <h2 className="fw-bold mb-2 text-uppercase">Återställ lösenord</h2>
                <p className="text-black-50 mb-5">Vänligen ange ditt nya lösenord!</p>

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="form-outline mb-4">
                  <Form.Label htmlFor="typeNewPasswordX" style={{ textAlign: 'left', width: '100%' }}>Nytt Lösenord</Form.Label>
                    <Form.Control
                      type="password"
                      id="typeNewPasswordX"
                      className="form-control form-control-lg"
                      placeholder="Nytt lösenord"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                  </Form.Group>

                  <Button variant="primary" className="btn btn-success btn-lg btn-block mb-3" type="submit">Återställ lösenord</Button>
                </Form>

                {message && <Alert variant="success">{message}</Alert>}
                {error && <Alert variant="danger">{error}</Alert>}
                
                <p className="small mb-4">
                  <a href="/login" className="text-blue">Tillbaka till inloggning</a>
                </p>

              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ResetPasswordForm;